// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kwQe","colMin":"styles_colMin__2QvEb"};